var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-entrance"},[_c('p',[_vm._v(" "+_vm._s(_vm.entranceName)+" ")]),_c('i',{staticClass:"icon-app_login"})])}
var staticRenderFns = []

export { render, staticRenderFns }